export default "---\nname: Extra repairs\ncount: 5\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"